import { createReducer } from '@reduxjs/toolkit';

import getArticlesDetails, { clearArticlesDetails } from '../../thunks/articles/getArticlesDetails';

const initialState = {
  loading: false,
  error: '',
  data: undefined,
};

const getArticlesDetailsReducer = createReducer(initialState, {
  [getArticlesDetails.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getArticlesDetails.fulfilled]: (state, { payload: { data } }) => ({
    ...state,
    loading: false,
    data,
  }),
  [clearArticlesDetails]: () => initialState,
  [getArticlesDetails.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    data: null
  }),
});

export default getArticlesDetailsReducer;
